<template>
  <Stepper :steps="steps" />
</template>

<script>
import Stepper from "@/components/nav/Stepper";

import ServersTable from "../ServersTableComponent";
import ServerCard from "../ServerCard";
import FileSelector from "./GoodsFileSelector";
import UploadSettings from "./GoodsSettings";
import UnitsComponent from "../UnitsComponent";
import CollisionCheck from "./CollizionCheckComponent";
import Info from "./PreUploadDigest";
import Upload from "./UploadGoodsComponent";
import Digest from "./UploadDigestComponent";

export default {
  data() {
    return {
      steps: [
        {
          title: "Выбор сервера",
          subtitle: "",
          component: ServersTable,
          props: { readOnly: true },
        },
        {
          title: "Соеденение",
          subtitle: "Проверка прав",
          component: ServerCard,
        },
        { title: "Выбор файла", component: FileSelector },
        {
          title: "Настройка",
          subtitle: "Общие параметры",
          component: UploadSettings,
        },
        {
          title: "Настройка",
          subtitle: "Соотношение ед.",
          component: UnitsComponent,
        },
        { title: "Дубликаты", component: CollisionCheck, color: "warning" },
        {
          title: "Отчет",
          subtitle: "Предварительный",
          component: Info,
          color: "warning",
        },
        { title: "Загрузка", component: Upload, color: "warning" },
        {
          title: "Отчет",
          subtitle: "Итоги загрузки",
          component: Digest,
          color: "blue",
        },
      ],
    };
  },
  components: {
    Stepper,
  },
};
</script>